import { pdfjs } from 'react-pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import createApp from './app';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
createApp();
